export default interface InvoiceGroup {
    id: number;
    name: string;
    foreign: string;
    english: string;
    dimCodeIn: string;
    dimCodeOut: string;
    controlPerson: number;
    user: number;
    defDivItem: number;
    contrType: number;
    carBrand: number;
    activity: number;
    deleted: boolean;
    deleting: boolean;
}

export const invoiceGroupDefaultProps: InvoiceGroup = {
    id: 0,
    name: '',
    foreign: '',
    english: '',
    dimCodeIn: '',
    dimCodeOut: '',
    controlPerson: 1,
    user: 0,
    defDivItem: 1,
    contrType: 1,
    carBrand: 1,
    activity: 1,
    deleted: false,
    deleting: false,
}
